import * as t from 'io-ts';
import { AircraftDynamicType } from './aircraft';
import { ContactDynamicType } from './contact';
import { AirportDetailsDynamicType } from './airport';
import { ItineraryAdditionalInformationDynamicType } from './itineraryAdditionalInformation';
import { PassengerDynamicType } from './passenger';
import { BrokerShortDetailsDynamicType } from './brokerDetails';
import { ItineraryLegDynamicType } from './itineraryLeg';

export const ItineraryDynamicType = t.interface({
    id: t.string,
    aircraft: AircraftDynamicType,
    flightNumber: t.string,
    captain: ContactDynamicType,
    firstOfficer: ContactDynamicType,
    flightAttendant: ContactDynamicType,
    airports: t.array(AirportDetailsDynamicType),
    additionalInformation: ItineraryAdditionalInformationDynamicType,
    passengers: t.array(PassengerDynamicType),
    accountManager: t.union([BrokerShortDetailsDynamicType, t.null]),
    flightManager: t.union([BrokerShortDetailsDynamicType, t.null]),
    itineraryLegs: t.array(ItineraryLegDynamicType),
    isLongStandingCustomer: t.boolean,
});

export type Itinerary = t.TypeOf<typeof ItineraryDynamicType>;
